var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6881 23.6973L24.3018 27.5551L28.2501 30.2691L32.1985 27.5551L31.8121 23.6974",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8153 14.4404V17.0275C35.8153 21.1889 32.4105 24.5937 28.2493 24.5937C24.088 24.5937 20.6831 21.1889 20.6831 17.0275V14.4404",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7945 10.9492H18.7051V14.2691H37.7945V10.9492Z",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3652 10.9484V10.1184C20.3652 8.54955 20.8238 7.08813 21.6137 5.85999M22.6904 4.52794C23.7417 3.48239 25.0864 2.73154 26.59 2.40918M29.9101 2.40929C33.4674 3.17165 36.1349 6.3333 36.1349 10.1184V10.9484",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5903 10.9491V2.40995C26.5903 1.49698 27.3373 0.75 28.2503 0.75C29.1633 0.75 29.9102 1.49698 29.9102 2.40995V10.9491",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3016 27.5558L18.0634 30.7695C15.8459 31.9119 13.5273 32.8111 13.5273 35.3056V42.7318L28.2499 52.6914L34.9236 48.1767M36.2988 47.2464L42.9725 42.7317L42.9726 35.3055C42.9726 32.8115 40.654 31.9118 38.4365 30.7694L32.1983 27.5557",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4167 26.1064L44.1494 28.7761M49.614 28.7761L49.3467 26.1064",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1504 28.7773L41.9959 29.9377C41.1313 30.4033 40.2412 30.8119 39.5225 31.3186M42.9729 42.7318H55.7501V33.9184C55.7501 31.7293 53.6964 30.9756 51.7695 29.9378L49.615 28.7775",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.614 28.7773C49.614 29.9818 48.3907 30.9582 46.8817 30.9582C45.3727 30.9582 44.1494 29.9818 44.1494 28.7773",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5078 19.0498H54.2571",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1185 18.1352C52.1185 15.2555 49.7624 12.8994 46.8828 12.8994C44.0032 12.8994 41.647 15.2555 41.647 18.1352V21.4922C41.647 24.3719 44.0031 26.728 46.8828 26.728C49.7624 26.728 52.1185 24.3719 52.1185 21.4922V18.1352Z",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8818 15.8265V10.8467",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0824 26.1064L12.3497 28.7761M6.88525 28.7761L7.15251 26.1064",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3497 28.7773L14.5042 29.9377C15.3688 30.4033 16.2589 30.8119 16.9777 31.3186M13.5272 42.7318H0.75V33.9184C0.75 31.7293 2.80369 30.9756 4.73067 29.9378L6.88528 28.7775",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88525 28.7773L9.61742 31.7882L12.3497 28.7773",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9915 19.0498H2.24219",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38184 18.1352C4.38184 15.2555 6.73797 12.8994 9.61754 12.8994C12.4971 12.8994 14.8533 15.2555 14.8533 18.1352V21.4922C14.8533 24.3719 12.4972 26.728 9.61754 26.728C6.73797 26.728 4.38184 24.3719 4.38184 21.4922V18.1352Z",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61768 15.8265V10.8467",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61768 31.7881V41.9017",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 30.2695V52.6911",
    stroke: "#EB2019",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCapacity);
export default __webpack_public_path__ + "static/media/icon-capacity.37592b88503cd58c087bbb985d3ca377.svg";
export { ForwardRef as ReactComponent };